import(/* webpackMode: "eager" */ "/vercel/path0/src/app/bridge/page.tsx");
